module.exports = __webpack_public_path__ + "img/tianmao.cd7c73ea.png";